import { Trans } from "@lingui/react/macro";

interface LoggedInStatusCellProps {
  isSignedIn: boolean;
}

const LoggedInStatusCell = ({ isSignedIn }: LoggedInStatusCellProps) => {
  if (!isSignedIn) {
    return null;
  }

  return <Trans>Inloggad</Trans>;
};

export default LoggedInStatusCell;
